// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b67d994","239":"78610058","455":"fd435d95","488":"149a6cae"}[chunkId] + ".chunk.js";
};